// extracted by mini-css-extract-plugin
export default {"about_me":"aboutMe_about_me__dq-jQ","wrapper":"aboutMe_wrapper__oZlDl","title":"aboutMe_title__je+2y","content":"aboutMe_content__SEkSo"};